import { useTranslate, useShow, useOne } from '@refinedev/core';
import { Show, TextField, DateField } from '@refinedev/antd';
import { Typography, Divider } from 'antd';
import { Link } from 'react-router-dom';
import type { FCMTokenOut, UserOut } from '@/api/generated/schemas';

const { Title } = Typography;

export const FCMTokenShow = () => {
  const t = useTranslate();
  const { query } = useShow<FCMTokenOut>({
    resource: 'account.fcm_tokens',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  const { result: user } = useOne<UserOut>({
    resource: 'iam.users',
    id: record?.user_id ?? 0,
    queryOptions: { enabled: !!record?.user_id },
  });

  return (
    <Show isLoading={isLoading}>
      <Title level={4}>{t('base.sections.basic_info')}</Title>

      <Title level={5}>{t('base.fields.id')}</Title>
      <TextField value={record?.id} />

      <Title level={5}>{t('account.fcm_tokens.fields.user_id')}</Title>
      {record?.user_id ? (
        <Link to={`/iam/users/${record.user_id}`}>
          {user?.email ?? user?.username ?? `#${record.user_id}`}
        </Link>
      ) : (
        <TextField value="-" />
      )}

      <Title level={5}>{t('account.fcm_tokens.fields.token')}</Title>
      <Typography.Text copyable>{record?.token ?? '-'}</Typography.Text>

      <Title level={5}>{t('account.fcm_tokens.fields.platform')}</Title>
      <TextField
        value={
          record?.platform
            ? t(`account.fcm_tokens.platform.${record.platform}`)
            : '-'
        }
      />

      <Title level={5}>{t('account.fcm_tokens.fields.app_version')}</Title>
      <TextField value={record?.app_version ?? '-'} />

      <Title level={5}>{t('account.fcm_tokens.fields.user_agent')}</Title>
      <TextField value={record?.user_agent ?? '-'} />

      <Title level={5}>{t('account.fcm_tokens.fields.ip_address')}</Title>
      <TextField value={record?.ip_address ?? '-'} />

      <Title level={5}>{t('account.fcm_tokens.fields.last_used_at')}</Title>
      {record?.last_used_at ? (
        <DateField value={record.last_used_at} format="LLL" />
      ) : (
        <TextField value="-" />
      )}

      <Divider />

      <Title level={4}>{t('base.sections.system_info')}</Title>

      <Title level={5}>{t('base.fields.created_at')}</Title>
      <DateField value={record?.created_at ?? undefined} format="LLL" />

      <Title level={5}>{t('base.fields.updated_at')}</Title>
      <DateField value={record?.updated_at ?? undefined} format="LLL" />
    </Show>
  );
};
